import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import { FaExclamationTriangle } from "react-icons/fa";
import useCommon from "hooks/useCommon";

const DeleteIntegrationDialog = ({ open, onClose, onConfirm, integration }) => {
  if (!integration) return null;

  const { STORE } = useCommon();
  const { deleteLoading } = STORE((state) => state.integrations);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent>
        <VuiBox textAlign="center" py={1}>
          <VuiBox>
            <FaExclamationTriangle size={32} color="#ff4d4f" />

            <VuiTypography variant="body2" mt={2}>
              Are you sure you want to permanently delete this integration?
            </VuiTypography>
          </VuiBox>

          <VuiTypography variant="caption">This action cannot be undone.</VuiTypography>
        </VuiBox>
      </DialogContent>

      <DialogActions>
        <VuiButton variant="outlined" color="primary" onClick={onClose}>
          Cancel
        </VuiButton>

        <VuiButton variant="contained" color="error" onClick={onConfirm} disabled={deleteLoading}>
          {deleteLoading ? "Deleting..." : "Delete"}
        </VuiButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteIntegrationDialog;
